import { Injectable, Injector } from '@angular/core';

import { ServiceAreasService } from './serviceAreas.service';
import { BaseReportService } from './reportBase.service';

import type { TServiceArea, IGetReportData } from '@shared/models';

@Injectable()
export class ReportServiceAreasService extends BaseReportService implements IGetReportData {
    private serviceAreasService: ServiceAreasService;

    constructor(injector: Injector) {
        super(injector);
        this.serviceAreasService = injector.get(ServiceAreasService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];

        const promise = new Promise((resolve) => {
            this.serviceAreasService.getAll()
                .then((serviceAreas: TServiceArea[]) => {
                    const sortedServiceAreas = serviceAreas.sort((a, b) => (a.zipcode > b.zipcode) ? 1 : -1);

                    // Calculate data rows here.
                    sortedServiceAreas.forEach((area) => {
                        const reportColValues: string[] = [
                            area.zipcode, area.distance + ' miles', area.city + ' , ' + area.regionName];
                        const rowInfo = this.buildRowInfo(reportColValues, 'data');
                        allRows.push(rowInfo);
                    });

                    allRows.push(undefined);
                    const reportData = { 'data': allRows };
                    resolve(reportData);
                });
        });
        return promise;
    }
}
